import { createRoute } from "../lib/createRoute";
import Affiliates from "../pages/Affiliates";

export const Route = createRoute(
  "/affiliates",
  Affiliates,
  "Flowstep Affiliate Program: Earn Commission",
  "The Flowstep Affiliate Program allows you to refer product builders to our AI design tool and earn commissions. Join the program in a couple of minutes.",
);
